import { createReducer, on } from '@ngrx/store';
import {
  NonBpsApprovedTerminalsActions,
  NonBpsApplicationDetailActions,
  NonBpsDeleteProductRequestActions,
  NonBpsDeleteRequestAttachmentActions,
  NonBpsManagementState,
  NonBpsMyApplicationsActions,
  NonBpsRequestAttachmentTypesActions,
  NonBpsRequestProgressActions,
  NonBpsProductRequestDetailActions,
  NonBpsProductRequestsActions,
  NonBpsSaveRequestArrivalDetailsActions,
  NonBpsSaveRequestConsigneeDetailsActions,
  NonBpsSaveRequestQuantitiesActions,
  NonBpsSaveRequestSupplierDetailsActions,
  NonBpsSaveProductRequestActions,
  NonBpsSubmitProductRequestActions,
  NonBpsUploadRequestAttachmentActions,
  NonBpsViewRequestAttachmentActions,
} from './non-bps-management.actions';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '@shared/ngrx-factory/factory.reducer';

const initialRequestState = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialNonBpsManagementState: NonBpsManagementState = {
  myApplications: { ...initialRequestState },
  applicationDetail: { ...initialRequestState },
  productRequests: { ...initialRequestState },
  productRequestDetail: { ...initialRequestState },
  approvedTerminals: { ...initialRequestState },
  requestProgress: { ...initialRequestState },
  requestAttachmentTypes: { ...initialRequestState },
  saveProductRequest: { ...initialRequestState },
  saveRequestQuantities: { ...initialRequestState },
  saveRequestArrivalDetails: { ...initialRequestState },
  saveRequestSupplierDetails: { ...initialRequestState },
  saveRequestConsigneeDetails: { ...initialRequestState },
  uploadRequestAttachment: { ...initialRequestState },
  viewRequestAttachment: { ...initialRequestState },
  deleteRequestAttachment: { ...initialRequestState },
  submitProductRequest: { ...initialRequestState },
  deleteProductRequest: { ...initialRequestState },
};

export const nonBpsManagementReducer = createReducer(
  initialNonBpsManagementState,

  on(NonBpsMyApplicationsActions.request, (state) => handleRequest(state, 'myApplications')),
  on(NonBpsMyApplicationsActions.success, (state, { response }) =>
    handleSuccess(state, 'myApplications', response),
  ),
  on(NonBpsMyApplicationsActions.failure, (state, { error }) =>
    handleFailure(state, 'myApplications', error),
  ),
  on(NonBpsMyApplicationsActions.clearState, (state) => handleClear(state, 'myApplications')),

  on(NonBpsApplicationDetailActions.request, (state) => handleRequest(state, 'applicationDetail')),
  on(NonBpsApplicationDetailActions.success, (state, { response }) =>
    handleSuccess(state, 'applicationDetail', response),
  ),
  on(NonBpsApplicationDetailActions.failure, (state, { error }) =>
    handleFailure(state, 'applicationDetail', error),
  ),
  on(NonBpsApplicationDetailActions.clearState, (state) => handleClear(state, 'applicationDetail')),

  on(NonBpsProductRequestsActions.request, (state) => handleRequest(state, 'productRequests')),
  on(NonBpsProductRequestsActions.success, (state, { response }) =>
    handleSuccess(state, 'productRequests', response),
  ),
  on(NonBpsProductRequestsActions.failure, (state, { error }) =>
    handleFailure(state, 'productRequests', error),
  ),
  on(NonBpsProductRequestsActions.clearState, (state) => handleClear(state, 'productRequests')),

  on(NonBpsProductRequestDetailActions.request, (state) =>
    handleRequest(state, 'productRequestDetail'),
  ),
  on(NonBpsProductRequestDetailActions.success, (state, { response }) =>
    handleSuccess(state, 'productRequestDetail', response),
  ),
  on(NonBpsProductRequestDetailActions.failure, (state, { error }) =>
    handleFailure(state, 'productRequestDetail', error),
  ),
  on(NonBpsProductRequestDetailActions.clearState, (state) =>
    handleClear(state, 'productRequestDetail'),
  ),

  on(NonBpsApprovedTerminalsActions.request, (state) => handleRequest(state, 'approvedTerminals')),
  on(NonBpsApprovedTerminalsActions.success, (state, { response }) =>
    handleSuccess(state, 'approvedTerminals', response),
  ),
  on(NonBpsApprovedTerminalsActions.failure, (state, { error }) =>
    handleFailure(state, 'approvedTerminals', error),
  ),
  on(NonBpsApprovedTerminalsActions.clearState, (state) => handleClear(state, 'approvedTerminals')),

  on(NonBpsRequestProgressActions.request, (state) => handleRequest(state, 'requestProgress')),
  on(NonBpsRequestProgressActions.success, (state, { response }) =>
    handleSuccess(state, 'requestProgress', response),
  ),
  on(NonBpsRequestProgressActions.failure, (state, { error }) =>
    handleFailure(state, 'requestProgress', error),
  ),
  on(NonBpsRequestProgressActions.clearState, (state) => handleClear(state, 'requestProgress')),

  on(NonBpsRequestAttachmentTypesActions.request, (state) =>
    handleRequest(state, 'requestAttachmentTypes'),
  ),
  on(NonBpsRequestAttachmentTypesActions.success, (state, { response }) =>
    handleSuccess(state, 'requestAttachmentTypes', response),
  ),
  on(NonBpsRequestAttachmentTypesActions.failure, (state, { error }) =>
    handleFailure(state, 'requestAttachmentTypes', error),
  ),
  on(NonBpsRequestAttachmentTypesActions.clearState, (state) =>
    handleClear(state, 'requestAttachmentTypes'),
  ),

  on(NonBpsSaveProductRequestActions.request, (state) =>
    handleRequest(state, 'saveProductRequest'),
  ),
  on(NonBpsSaveProductRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'saveProductRequest', response),
  ),
  on(NonBpsSaveProductRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'saveProductRequest', error),
  ),
  on(NonBpsSaveProductRequestActions.clearState, (state) =>
    handleClear(state, 'saveProductRequest'),
  ),

  on(NonBpsSaveRequestQuantitiesActions.request, (state) =>
    handleRequest(state, 'saveRequestQuantities'),
  ),
  on(NonBpsSaveRequestQuantitiesActions.success, (state, { response }) =>
    handleSuccess(state, 'saveRequestQuantities', response),
  ),
  on(NonBpsSaveRequestQuantitiesActions.failure, (state, { error }) =>
    handleFailure(state, 'saveRequestQuantities', error),
  ),
  on(NonBpsSaveRequestQuantitiesActions.clearState, (state) =>
    handleClear(state, 'saveRequestQuantities'),
  ),

  on(NonBpsSaveRequestArrivalDetailsActions.request, (state) =>
    handleRequest(state, 'saveRequestArrivalDetails'),
  ),
  on(NonBpsSaveRequestArrivalDetailsActions.success, (state, { response }) =>
    handleSuccess(state, 'saveRequestArrivalDetails', response),
  ),
  on(NonBpsSaveRequestArrivalDetailsActions.failure, (state, { error }) =>
    handleFailure(state, 'saveRequestArrivalDetails', error),
  ),
  on(NonBpsSaveRequestArrivalDetailsActions.clearState, (state) =>
    handleClear(state, 'saveRequestArrivalDetails'),
  ),

  on(NonBpsSaveRequestSupplierDetailsActions.request, (state) =>
    handleRequest(state, 'saveRequestSupplierDetails'),
  ),
  on(NonBpsSaveRequestSupplierDetailsActions.success, (state, { response }) =>
    handleSuccess(state, 'saveRequestSupplierDetails', response),
  ),
  on(NonBpsSaveRequestSupplierDetailsActions.failure, (state, { error }) =>
    handleFailure(state, 'saveRequestSupplierDetails', error),
  ),
  on(NonBpsSaveRequestSupplierDetailsActions.clearState, (state) =>
    handleClear(state, 'saveRequestSupplierDetails'),
  ),

  on(NonBpsSaveRequestConsigneeDetailsActions.request, (state) =>
    handleRequest(state, 'saveRequestConsigneeDetails'),
  ),
  on(NonBpsSaveRequestConsigneeDetailsActions.success, (state, { response }) =>
    handleSuccess(state, 'saveRequestConsigneeDetails', response),
  ),
  on(NonBpsSaveRequestConsigneeDetailsActions.failure, (state, { error }) =>
    handleFailure(state, 'saveRequestConsigneeDetails', error),
  ),
  on(NonBpsSaveRequestConsigneeDetailsActions.clearState, (state) =>
    handleClear(state, 'saveRequestConsigneeDetails'),
  ),

  on(NonBpsUploadRequestAttachmentActions.request, (state) =>
    handleRequest(state, 'uploadRequestAttachment'),
  ),
  on(NonBpsUploadRequestAttachmentActions.success, (state, { response }) =>
    handleSuccess(state, 'uploadRequestAttachment', response),
  ),
  on(NonBpsUploadRequestAttachmentActions.failure, (state, { error }) =>
    handleFailure(state, 'uploadRequestAttachment', error),
  ),
  on(NonBpsUploadRequestAttachmentActions.clearState, (state) =>
    handleClear(state, 'uploadRequestAttachment'),
  ),

  on(NonBpsViewRequestAttachmentActions.request, (state) =>
    handleRequest(state, 'viewRequestAttachment'),
  ),
  on(NonBpsViewRequestAttachmentActions.success, (state, { response }) =>
    handleSuccess(state, 'viewRequestAttachment', response),
  ),
  on(NonBpsViewRequestAttachmentActions.failure, (state, { error }) =>
    handleFailure(state, 'viewRequestAttachment', error),
  ),
  on(NonBpsViewRequestAttachmentActions.clearState, (state) =>
    handleClear(state, 'viewRequestAttachment'),
  ),

  on(NonBpsDeleteRequestAttachmentActions.request, (state) =>
    handleRequest(state, 'deleteRequestAttachment'),
  ),
  on(NonBpsDeleteRequestAttachmentActions.success, (state, { response }) =>
    handleSuccess(state, 'deleteRequestAttachment', response),
  ),
  on(NonBpsDeleteRequestAttachmentActions.failure, (state, { error }) =>
    handleFailure(state, 'deleteRequestAttachment', error),
  ),
  on(NonBpsDeleteRequestAttachmentActions.clearState, (state) =>
    handleClear(state, 'deleteRequestAttachment'),
  ),

  on(NonBpsSubmitProductRequestActions.request, (state) =>
    handleRequest(state, 'submitProductRequest'),
  ),
  on(NonBpsSubmitProductRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'submitProductRequest', response),
  ),
  on(NonBpsSubmitProductRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'submitProductRequest', error),
  ),
  on(NonBpsSubmitProductRequestActions.clearState, (state) =>
    handleClear(state, 'submitProductRequest'),
  ),

  on(NonBpsDeleteProductRequestActions.request, (state) =>
    handleRequest(state, 'deleteProductRequest'),
  ),
  on(NonBpsDeleteProductRequestActions.success, (state, { response }) =>
    handleSuccess(state, 'deleteProductRequest', response),
  ),
  on(NonBpsDeleteProductRequestActions.failure, (state, { error }) =>
    handleFailure(state, 'deleteProductRequest', error),
  ),
  on(NonBpsDeleteProductRequestActions.clearState, (state) =>
    handleClear(state, 'deleteProductRequest'),
  ),
);
